/* this file is transformed by vux-loader */
/* eslint-disable */
import LoadingPlugin from "vux/src/plugins/loading/index.js" // this line is trasformed by vux-loader
import ToastPlugin from "vux/src/plugins/toast/index.js" // this line is trasformed by vux-loader
var plugin = {
  install: function install(Vue) {
    // 注册
    Vue.use(LoadingPlugin);
    Vue.use(ToastPlugin); // toast

    Vue.prototype.$toast = Vue.$toast = function (options) {
      if (!options.text) {
        options = {
          type: 'text',
          text: options,
          position: 'bottom'
        };
      }

      Vue.$vux.toast.show(options);
    }; // loading


    Vue.prototype.$loading = Vue.$loading = function (options) {
      if (!options || !options.text) {
        console.log(options);
        options = {
          text: options || '加载中...'
        };
      }

      Vue.$vux.loading.show(options);
    }; // hide


    Vue.prototype.$hide = Vue.$hide = function (options) {
      Vue.$vux.toast.hide();
      Vue.$vux.loading.hide();
    };
  }
};
export default plugin;